<!--  -->
<template>
  <div class="">
    <div class="btns">
      <el-button
        size="mini"
        v-if="tableData.length == 0"
        type="primary"
        @click="addTeacher"
        >新增</el-button
      >
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="Id" label="Id" width="150"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="DeleteProcessEvaluationTable(scope.row.Id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 修改 -->
    <div class="mask" v-if="showMask">
      <div class="mask_title">修改</div>
      <el-form
        ref="form"
        :model="editForm"
        label-width="80px"
        class="form"
        :rules="rules"
      >
        <el-form-item label="问题" style="margin-top: 20px" prop="name">
          <el-input v-model="editForm.Question"></el-input>
        </el-form-item>
        <el-form-item label="排序" style="margin-top: 20px" prop="name">
          <el-input v-model="editForm.OrderSort"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 40px">
          <el-button type="primary" @click="PreserveUpdate">提交</el-button>
          <el-button @click="closeAdd">关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 添加 -->
    <el-dialog title="表格1" :visible.sync="dialogVisibleTable" width="50%">
      <div>
        <el-row class="demo-el-row">
          <el-col :span="12">
            <div class="demo-el-col dark bd-top bd-bottom bd-left bd-right">
              <input
                type="text"
                v-model="tableParams.titleTab1"
                placeholder="孩子姓名:"
                value=""
                class="table-input"
              />
              <input
                type="text"
                v-model="tableParams.name"
                value=""
                placeholder="请输入内容"
                class="table-input"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-top bd-bottom bd-right">
              <input
                type="text"
                v-model="tableParams.titleTab2"
                placeholder="内容:"
                value=""
                class="table-input"
              />
              <input
                type="text"
                v-model="tableParams.content"
                value=""
                placeholder="请输入内容"
                class="table-input"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-left bd-right">
              <input
                type="text"
                v-model="tableParams.titleTab3"
                placeholder="观察日期:"
                value=""
                class="table-input"
              />
              <input
                type="text"
                v-model="tableParams.looktime"
                value=""
                placeholder="请输入内容"
                class="table-input"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-right">
              <input
                type="text"
                v-model="tableParams.titleTab4"
                placeholder="记录人:"
                value=""
                class="table-input"
              />
              <input
                type="text"
                v-model="tableParams.writename"
                value=""
                placeholder="请输入内容"
                class="table-input"
              />
            </div>
          </el-col>
          <el-col v-for="(item, index) in tableParams.List" :key="index">
            <div
              class="demo-el-col light bd-left bd-bottom bd-right"
              style="height: 120px; flex-direction: column"
            >
              <input
                v-model="item.title"
                class="table-textareas"
                placeholder="请填写标题："
              />
              <textarea
                v-model="item.desc"
                type="textarea"
                class="table-textareas"
                style="height: 80px; border: 0; outline: none; resize: none"
                oninput="if(value.length>140)value=value.slice(0,140)"
              />
            </div>
          </el-col>
        </el-row>
        <div style="text-align: center; padding: 20px" @click.stop="onClickAdd">
          <i class="el-icon-circle-plus-outline" style="font-size: 60px"></i>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTable = false">取 消</el-button>
        <el-button type="primary" @click="onClickTableAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetProcessEvaluationTable,
  UpdateProceQuestion,
  DeleteProcessEvaluationTable,
  AddProcessEvaluationTable,
  GetProcessEvaluationTableSigin,
  GetEditQuestion,
} from "../../api/api";
export default {
  //import引入的组件需要注入到对象中才能使用

  data() {
    //这里存放数据
    return {
      RoleId: "",
      RoleIndex: 0,
      roleType: 1,
      dialogVisibleRole: false,
      EditMask: false, //设置弹窗show
      dialogVisibleTable: false,
      data: [], //树的数据
      checked: [], //默认选中项
      optionsStudy: [],
      studyName: "",
      StudyId: "",
      checkedInfos: [], //选中的信息
      defaultProps: {
        children: "Children",
        label: "Label",
        Id: "Id",
      },
      tableParams: {
        titleTab1: "",
        titleTab2: "",
        titleTab3: "",
        titleTab4: "",
        title_1: "表现:",
        title_2: "问题原因:",
        title_3: "解决问题计:",
        title_4: "变化/成长:",
        List: [
          {
            title: "",
            desc: "",
          },
        ],
        name: "",
        content: "",
        looktime: "",
        writename: "",
        performance: "",
        questionreason: "",
        Problemplan: "",
        change: "",
      },
      dialogVisible: false, //文件上传弹窗
      teacherId: "", //设置的教师Id
      excelurl: "", //上传文件返回url
      title: "权限管理", //内容标题
      showMask: false, //编辑弹窗
      AddMask: false, //添加弹窗
      PwdMask: false, //密码弹窗
      tableData: [], //教师列表
      tableDataTwo: [],
      addForm: {
        Question: "",
        OrderSort: null,
      }, //添加信息对象
      rules: {
        Question: [{ required: true, message: "请输入问题", trigger: "blur" }],
        OrderSort: [
          { required: true, message: "请选择是否置顶", trigger: "blur" },
        ],
      }, //输入框判定
      editForm: {
        Question: "",
        OrderSort: null,
        Id: 0,
      }, //修改信息对象
      pwdForm: {
        password: "",
      }, //重置密码
      selsectId: [], //多选选中的Id
      page: 1, //初始页码
      PageSize: 10,
      LastPage: "", //总页数
      total: 0,
      tableId: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击添加表格
    onClickAdd() {
      if (this.tableParams.List.length == 9) {
        this.$message({
          type: "error",
          message: "超出添加限制!",
        });
      } else {
        var obj = {
          title: "",
          desc: "",
        };
        this.tableParams.List.push(obj);
      }
    },
    // 表格提交
    onClickTableAdd() {
      if (this.tableParams.titleTab1 == "") {
        this.tableParams.titleTab1 = "孩子姓名：";
      }
      if (this.tableParams.titleTab2 == "") {
        this.tableParams.titleTab2 = "内容:";
      }
      if (this.tableParams.titleTab3 == "") {
        this.tableParams.titleTab3 = "观察日期：";
      }
      if (this.tableParams.titleTab4 == "") {
        this.tableParams.titleTab4 = "记录人：";
      }
      //console.log(this.tableParams);
      let params = {
        // Id: this.tableId,
        type: 1,
        content: JSON.stringify(this.tableParams),
      };
      AddProcessEvaluationTable(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.dialogVisibleTable = false;
          this.GetProcessEvaluationTable();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    chooseRole(index) {
      this.RoleIndex = index;
      this.roleType = index + 1;
    },
    async SubmitRole() {
      let res = await SetTeacherRole({
        teacherId: this.RoleId,
        roleType: this.roleType,
      });
      if (res.data.success) {
        this.GetProcessEvaluationTable();
        this.dialogVisibleRole = false;
        this.$message({
          message: res.data.msg,
          type: "success",
        });
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    //获取问题信息列表
    GetProcessEvaluationTable() {
      GetProcessEvaluationTable({
        PageIndex: 1,
        PageSize: 10,
        Name: "",
        TypeId: this.TypeId,
      }).then((res) => {
        if (res.data.success) {
          // //console.log(res.data.response);
          this.tableData = res.data.response.data;
          this.LastPage = res.data.response.pageCount;
          this.page = 1;
        } else {
          this.tableData = [];
        }
      });
    },
    //新增教师人员
    addTeacher() {
      this.dialogVisibleTable = true;
      this.tableParams = {
        titleTab1: "",
        titleTab2: "",
        titleTab3: "",
        titleTab4: "",
        title_1: "表现:",
        title_2: "问题原因:",
        title_3: "解决问题计:",
        title_4: "变化/成长:",
        List: [
          {
            title: "",
            desc: "",
          },
        ],
        name: "",
        content: "",
        looktime: "",
        writename: "",
        performance: "",
        questionreason: "",
        Problemplan: "",
        change: "",
      };
    },
    //多选功能
    handleSelectionChange(val) {
      let list = [];
      val.forEach((item) => {
        //  //console.log(item.Id);
        if (!list.includes(item.Id)) {
          list.push(item.Id);
        }
      });
      this.selsectId = list;
      //console.log(this.selsectId);
    },
    //删除学校问题按钮
    DeleteProcessEvaluationTable(id) {
      DeleteProcessEvaluationTable({
        ids: [id],
      }).then((res) => {
        if (res.data.success) {
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.GetProcessEvaluationTable();
          }
        }
      });
    },
    //模板重置密码按钮
    reset() {
      if (this.pwdForm.password) {
        ResetPwd({
          ids: this.selsectId,
          newPwd: this.pwdForm.password,
        }).then((res) => {
          if (res.status == 200) {
            this.PwdMask = false;
            this.$message({
              message: "更改成功",
              type: "success",
            });
          }
        });
      } else {
        this.$message({
          message: "请输入密码",
        });
      }
    },
    //关闭重置模板
    CloseReset() {
      this.PwdMask = false;
    },
    //编辑按钮
    handleEdit(index, row) {
      GetProcessEvaluationTableSigin({ Id: row.Id }).then((res) => {
        if (res.data.success) {
          this.tableParams = JSON.parse(res.data.response.Content);
          this.tableId = row.Id;
          this.dialogVisibleTable = true;
        }
      });
    },
    //提交新增信息
    PreserveAdd() {
      if (this.addForm.OrderSort && this.addForm.Question) {
        AddProceQuestion({
          Question: this.addForm.Question,
          OrderSort: this.addForm.OrderSort,
        })
          .then((res) => {
            if (res.status == 200) {
              this.GetProcessEvaluationTable();
              if (res.data.success == true) {
                this.$message({
                  message: "增加成功",
                  type: "success",
                });
              } else if (res.data.success == false) {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            }
          })
          .catch((err) => {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
        // //console.log(this.addForm);
        this.AddMask = false;
        this.addForm = {
          Question: "",
          OrderSort: null,
        };
      } else {
        this.$message({
          message: "请补充添加信息",
        });
      }
    },
    //编辑
    PreserveUpdate() {
      //console.log(this.editForm);
      if (this.editForm.OrderSort && this.editForm.Question) {
        UpdateProceQuestion({
          Id: this.editForm.Id,
          Question: this.editForm.Question,
          OrderSort: this.editForm.OrderSort,
        })
          .then((res) => {
            if (res.status == 200) {
              this.GetProcessEvaluationTable();
              if (res.data.success == true) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else if (res.data.success == false) {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            }
          })
          .catch((err) => {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
        // //console.log(this.addForm);
        this.showMask = false;
        this.addForm = {
          Question: "",
          OrderSort: null,
          Id: 0,
        };
      } else {
        this.$message({
          message: "请补充添加信息",
        });
      }
    },
    //关闭提交模态框
    closeAdd() {
      this.AddMask = false;
      this.showMask = false;
    },
    //上一页
    prevPage() {
      if (this.page > 1) {
        this.page--;
        GetProcessEvaluationTable({
          PageIndex: this.page,
          PageSize: 10,
        }).then((res) => {
          if (res.status == 200) {
            //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
          }
        });
      } else {
        this.$message({
          message: "当前已是首页",
        });
      }
    },
    //下一页
    nextPage() {
      if (this.page < this.LastPage) {
        this.page++;
        GetProcessEvaluationTable({
          PageIndex: this.page,
          PageSize: 10,
        }).then((res) => {
          if (res.status == 200) {
            //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
          }
        });
      } else {
        this.$message({
          message: "当前已是尾页",
        });
      }
    },
    //尾页
    toLastPage() {
      this.page = this.LastPage;
      GetProcessEvaluationTable({
        PageIndex: this.page,
        PageSize: 10,
      }).then((res) => {
        if (res.status == 200) {
          //console.log(res.data.response.data);
          this.tableData = res.data.response.data;
        }
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  mounted() {
    this.GetProcessEvaluationTable();
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.demo-el-col {
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;

  .table-textareas {
    width: 100%;
    font-size: 10px;
    font-weight: bold;
    color: #000000;
    padding-top: 10px;
    // margin: 0 auto;
  }
}
.btn-confirm {
  width: 290px;
  height: 50px;
  background: #4cbff4;
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto;
}
.table-input {
  // width: 100%;
  height: 30px;
}
input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}
.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}
.role {
  width: 120px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 5px;
}
.roles {
  background: #409eff;
  color: #ffffff;
  border-color: #409eff;
}

.table {
  margin-top: 20px;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
.mask {
  width: 500px;
  height: 420px;
  position: absolute;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 24%;
  top: 20%;
}
.mask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
.form {
  padding: 10px 30px;
}
.editmask {
  position: absolute;
  z-index: 100;
  /* margin: 0 auto; */
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 30%;
  top: 0%;
}
.editmask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
</style>